<template>
    <div>
        <el-row type="flex" justify="center">
            <el-col :span="10">
                <el-form ref="form" :model="form" :rules="rules">
                    <el-form-item label="对象名称" prop="name">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone_num">
                        <el-input v-model="form.phone_num"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <Tag v-for="(tag, index) in tags" checkable :checked="is_checked" @click.native="checkTag(tag, index)" class="tag" color="#008080" :key="index">{{tag.tag_name}}</Tag>
                    </el-form-item>
                    <el-form-item>
                        <Button v-if="!inputVisible" class="new_tag_btn" icon="ios-add" type="dashed" size="small" @click="handleAdd">新 增 标 签</Button>
                        <el-input v-if="inputVisible" @blur="handleBlur" @keyup.enter.native="$event.target.blur" v-model="input_tag" size="small" placeholder="输入标签">
                            <template slot="append">
                                <el-button class="button-new-tag" size="small" @click="handleBlur">添加标签</el-button>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" class="btn-create" @click="onSubmit">新增对象</el-button>
                        <el-button type="text"  @click="pageToList">查看和管理对象-></el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { Tag } from 'iview';
import axios from 'axios';
import config from '../../config.js'
export default {
    components: {
        Tag,
    },
    props:['group_id'],
    data() {
        return {
            group: {
                group_id:'',
                group_name:''
            },
            checkList: [],
            form: {
                name: '',
                phone_num: ''
            },

            rules: {
                name: [
                    { required: true, message: '请输入对象名称', trigger: 'blur' }
                ]
            },
            tags: [],
            inputVisible: false,
            input_tag: '',
            is_checked: false,
            tags_ids: []
        }
    },
    created() {
        //console.log(this.group_id)
        this.group.group_id = this.group_id
        this.getGroup()
        this.getTags();
    },
    methods: {
        getGroup() {
            let url = config.base_url + '/yun_table/yun_duixiang_groups/' + this.group.group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                let res = response.data
                this.group.group_id = res.group_id
                this.group.group_name = res.group_name
            })
        },
        pageToList(){
            this.$router.push({
                        name: 'duixianglists',
                        params: {
                            group_id: this.group.group_id
                        }
                    })
            
        },
        onSubmit() {
            console.log('submit!')
            if (!this.validata()) {
                this.$message({
                    type: 'error',
                    message: '请填写正确的手机号'
                })
            }
            if (this.tags_ids.length >= 6) {
                this.$message({
                    message: '您最多可以选择6个标签',
                    type: 'info'
                });
                return false
            }
            axios({
                method: 'post',
                url: config.base_url + '/yun_table/yun_duixiang?group_id=' + this.group.group_id,
                headers: {
                    "Authorization": localStorage.getItem('token')
                },
                data: {
                    tags_ids: this.tags_ids,
                    duixiang_name: this.form.name,
                    duixiang_phone_num: this.form.phone_num
                }
            }).then((response) => {
                console.log(response.status);
                this.$message({
                    message: '对象' + response.data.duixiang_name + '新增成功',
                    type: 'success'
                });
                this.form.name = ''
                this.form.phone_num = ''

            }).catch((err) => {
                //console.log(err.response)
                let err_data = err.response.data.err_msg
                this.$message({
                    message: err_data,
                    type: 'error'
                })
            })

        },
        validata() {
            let phone_num = this.form.phone_num
            if (phone_num !== '') {
                if (((/^1[34578]\d{9}$/).test(phone_num))) {
                    return true
                }
                return false
            } else {
                return true
            }

        },
        getTags() {
            //console.log('getTags')
            let url = config.base_url + '/yun_table/yun_duixiang_tags?group_id=' + this.group.group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                this.tags = response.data
            })
        },




        pageToTagsManage() {
            this.$router.push({
                name: 'tags_manage',
                params: {
                    group_id: this.group.group_id
                }
            })
        },
        handleAdd() {
            this.inputVisible = true

        },
        handleBlur() {
            let _this = this
            console.log(this.input_tag)
            axios({
                    method: 'post',
                    url: config.base_url + '/yun_table/yun_duixiang_tags?group_id=' + this.group.group_id,
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    },
                    data: {
                        tag_name: this.input_tag
                    }
                })
                .then(function(response) {
                    //console.log(response)
                    _this.tags.push(response.data)
                    _this.input_tag = ''
                    _this.$message({
                        message: '标签新增成功',
                        type: 'success'
                    });
                })
                .catch((err) => {
                    //console.log(err.response)
                    let err_data = err.response.data.err_msg
                    this.$message({
                        message: err_data,
                        type: 'error'
                    })
                })
            this.inputVisible = false

        },
        checkTag(tag, index) {
            let tags_ids = this.tags_ids

            function hasTag() {
                for (let i = 0; i < tags_ids.length; i++) {
                    if (tags_ids[i] == tag.tag_id) {
                        return true
                    }
                }
            }
            if (hasTag()) {
                this.tags_ids = this.tags_ids.splice(index, 1)
            } else {
                this.tags_ids.push(tag.tag_id)
            }

            //console.log(tag.tag_id)
        }

    }

}
</script>
<style>
.tag,
.new_tag_btn {
    float: left;
}

.tag {
    margin: 10px;
}
</style>